// Display · CopyableValue helpers
//
// Format enum + display formatting. Split out of `CopyableValue.tsx` so that
// module exports components only.

export type CopyableFormat =
  | "iban"
  | "nip"
  | "bdo"
  | "eori"
  | "krs"
  | "regon"
  | "wasteCode"
  | "invoiceNumber"
  | "reference"
  | "endToEndId"
  | "email"
  | "phone"
  | "plain";

/** Returns the display string for a given format. */
export function formatCopyableDisplay(value: string, format: CopyableFormat): string {
  if (format === "iban") {
    return value.replace(/\s+/g, "").replace(/(.{4})/g, "$1 ").trim();
  }
  if (format === "nip") {
    return value.replace(/\D/g, "");
  }
  return value;
}
